export const watchConfigKeys = {
    firstTimeSendingData: 'firstTimeSendingData',
    intervalSendingData: 'intervalSendingData',
    intervalReadingSteps: 'intervalReadingSteps',
    intervalReadingHeartRate: 'intervalReadingHeartRate',
    intervalReadingLocation: 'intervalReadingLocation',
    intervalReadingSp02: 'intervalReadingSp02',
    intervalReadingTemperature: 'intervalReadingTemperature',
    intervalReadingSleep: 'intervalReadingSleep',
}

export const watchConfigList = [
    {
        key: watchConfigKeys.firstTimeSendingData,
        label: 'First Time Data Retrieval',
        min: 1,
        leftLabel: 'After',
    },
    {
        key: watchConfigKeys.intervalSendingData,
        label: 'Interval Data Retrieval',
        min: 5,
    },
    {
        key: watchConfigKeys.intervalReadingSteps,
        label: 'Interval Steps Reading',
        min: 30,
    },
    {
        key: watchConfigKeys.intervalReadingHeartRate,
        label: 'Interval Heart Rate Reading',
        min: 30,
    },
    {
        key: watchConfigKeys.intervalReadingLocation,
        label: 'Interval Location Reading',
        min: 30,
    },
    {
        key: watchConfigKeys.intervalReadingSp02,
        label: 'Interval SP02 Reading',
        min: 30,
    },
    {
        key: watchConfigKeys.intervalReadingTemperature,
        label: 'Interval Temperature Reading',
        min: 30,
    },
    {
        key: watchConfigKeys.intervalReadingSleep,
        label: 'Interval Sleep Reading',
        min: 30,
    },
]
